import React from 'react'
import { Tag } from 'antd'
import { useIntl } from 'react-intl'

/** Named so a column sizing itself to its content can account for this tag, which sits in the row
 * and does not shrink. */
export const ADP_FLAG_MESSAGE_ID = 'automations.adpAbbreviation'

export const ADPFlag = () => {
  const { formatMessage } = useIntl()
  return <Tag color="green">{formatMessage({ id: ADP_FLAG_MESSAGE_ID })}</Tag>
}
